import type { PredictionMarketChoice } from "@roman/shared/types/PredictionMarket";
import {
  PredictionMarketType,
  getPredictionMarketType,
  getYesNoChoices,
} from "@roman/shared/utils/predictionMarket/utils";
import type React from "react";

interface YesNoTabsProps {
  choices: PredictionMarketChoice[];
  selectedChoice: PredictionMarketChoice | undefined;
  setSelectedChoice: (choice: PredictionMarketChoice) => void;
}

export const YesNoTabs: React.FC<YesNoTabsProps> = ({ choices, selectedChoice, setSelectedChoice }) => {
  const marketType = getPredictionMarketType(choices.map((c) => ({ name: c.name })));
  if (marketType !== PredictionMarketType.TwoChoice) {
    throw new Error("YesNoTabs can only be used with YES/NO market type choices.");
  }

  const { yesChoice, noChoice } = getYesNoChoices(choices);

  if (!selectedChoice) {
    setSelectedChoice(yesChoice);
  }

  return (
    <div className="flex border-b text-dark-gray">
      <button
        key={yesChoice.id}
        className="flex-1 py-2 text-center font-bold transition border-b-2"
        style={
          selectedChoice?.id === yesChoice.id
            ? {
                color: "#00AFCE",
                borderBottomColor: "#00AFCE",
              }
            : {
                borderBottomColor: "#ECECEC",
              }
        }
        onClick={() => setSelectedChoice(yesChoice)}
        type="button"
      >
        {yesChoice.name}
      </button>
      <button
        key={noChoice.id}
        className="flex-1 py-2 text-center font-bold transition border-b-2"
        style={
          selectedChoice?.id === noChoice.id
            ? {
                color: "#FF7FD2",
                borderBottomColor: "#FF7FD2",
              }
            : {
                borderBottomColor: "#ECECEC",
              }
        }
        onClick={() => setSelectedChoice(noChoice)}
        type="button"
      >
        {noChoice.name}
      </button>
    </div>
  );
};
